import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { Modal } from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';

export const DeleteModal = (
  { isModalOpen, closeModal, onConfirm, title, description },
  { intl }
) => {
  const i18n = id => intl.formatMessage({ id });
  const TITLE = i18n(title);
  const DESCRIPTION = i18n(description);
  const CONFIRM = i18n('general.form.delete');
  const CANCEL = i18n('general.form.cancel');

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="">
      <ConfirmationDialog
        title={TITLE}
        labelConfirm={CONFIRM}
        labelCancel={CANCEL}
        onConfirm={onConfirm}
        onCancel={closeModal}
      >
        {DESCRIPTION}
      </ConfirmationDialog>
    </Modal>
  );
};

DeleteModal.propTypes = {
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string
};

DeleteModal.contextTypes = {
  intl: PropTypes.object
};

export default pure(DeleteModal);
